/**
 * Created by lihanying on 2017/6/26.
 */
import React from 'react'
import { DeleteOutlined, UserOutlined } from '@ant-design/icons'
import { Card, Avatar } from 'antd'
import Popconfirm from '../../../components/Popconfirm/Popconfirm2'
import Add from '../../../assert/images/add.svg'
import Modal from './modal'
import './style.css'

export default class extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      visible: false,
      record: {},
    }
  }

  showModal = (item) => {
    this.setState({ visible: true, roleItem: item })
  }
  handleOk = (e) => {
    const data = {
      memberId: this.props.deployInfo.id,
      clubRoleId: this.state.roleItem.id,
      region: sessionStorage.getItem('region_id'),
    }
    this.props.fetchSettingDeploy('SetBossRole', data) //新增
    this.setState({ visible: false, record: {} })
  }

  handleCancel = (e) => {
    this.setState({ visible: false, record: {} })
  }

  deleteEvent = (item) => {
    this.props.fetchSettingDeploy('CancelBossRole', {
      memberId: item.member_id,
      roleMemberId: item.id,
    })
  }

  render() {
    const { deployList, deployInfo, regionList } = this.props

    return (
      <div className="deploy">
        {deployList &&
          deployList.map((item, idx) => {
            return (
              <Card
                key={idx}
                title={item.role_name}
                extra={
                  <div>
                    <img
                      src={Add}
                      className="deploy-icon-img"
                      alt="Compile"
                      onClick={() => this.showModal(item)}
                    />
                  </div>
                }
                style={{ width: '32%', margin: '0 1% 1rem 0' }}
              >
                {item.listAccount &&
                  item.listAccount.map((list, id) => {
                    return (
                      <div key={id} className="deploy-list">
                        <div className="deploy-img">
                          <Avatar
                            size="large"
                            icon={<UserOutlined />}
                            src={list.avatar}
                          />
                        </div>
                        <div className="deploy-right">
                          <div className="deploy-info">
                            <div>
                              <span>电话:</span>
                              <span>{list.account}</span>
                            </div>
                            <div>
                              <span>姓名:</span>
                              <span>{list.member_name}</span>
                            </div>
                          </div>
                          <div style={{ lineHeight: '54px' }}>
                            <Popconfirm
                              title={`你确认要删除${list.member_name}管理员吗?`}
                              okText="确认"
                              cancelText="取消"
                              onConfirm={() => this.deleteEvent(list)}
                            >
                              <DeleteOutlined style={{ fontSize: '21px' }} />
                            </Popconfirm>
                          </div>
                        </div>
                      </div>
                    )
                  })}
              </Card>
            )
          })}

        {this.state.visible && (
          <Modal
            {...this.state}
            deployInfo={deployInfo}
            regionList={regionList}
            handleOk={this.handleOk}
            handleCancel={this.handleCancel}
            fetchGetAccount={this.props.fetchGetAccount}
          />
        )}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/containers/ClubDeploy/component/deploy.js